import { createContext } from 'react';

export const AuthContext = createContext({
  // Client-side user (normal app)
  user: null, // { id, role: 'user', ... } | null

  // Admin-side user
  admin: null, // { id, role: 'admin', ... } | null

  // Auth states
  isUserAuthenticated: false,
  isAdminAuthenticated: false,

  loading: true,

  // setters
  setUser: () => {},
  setAdmin: () => {},
  setIsUserAuthenticated: () => {},
  setIsAdminAuthenticated: () => {},
});
